import ICreateBirthdayCheckoutSession from '../Models/ICreateBirthdayCheckoutSession';
import ICreateVisitCheckoutSession from '../Models/ICreateVisitCheckoutSession';
import ICreateCheckoutSessionResponse from '../Models/ICreateCheckoutSessionResponse';
import BaseApi from './BaseApi';
import ICreateSpecialEventCheckoutSession from '../Models/ICreateSpecialEventCheckoutSession';
import { AxiosResponse } from 'axios';

/**
 * The StripeApi class.
 *
 */
class StripeApi extends BaseApi {
	constructor() {
        super('stripe');
	}
	
	/** 
	 * Create new visit session
	 * 
	 * @return {Promise} The request promise.
	*/
	public createVisitSession = (session: ICreateVisitCheckoutSession): Promise<AxiosResponse<ICreateCheckoutSessionResponse>> => {		
		return this._post('visits/create-checkout-session', session);
	}

	/** 
	 * Create new birthday session
	 * 
	 * @return {Promise} The request promise.
	*/
	public createBirthdaySession = (session: ICreateBirthdayCheckoutSession): Promise<AxiosResponse<ICreateCheckoutSessionResponse>> => {		
		return this._post('birthdays/create-checkout-session', session);
	}

	/** 
	 * Create new special event session
	 * 
	 * @return {Promise} The request promise.
	*/
	public createSpecialEventSession = (session: ICreateSpecialEventCheckoutSession): Promise<AxiosResponse<ICreateCheckoutSessionResponse>> => {		
		return this._post('specialevents/create-checkout-session', session);
	}

	/** 
	 * Get public  key
	 * 
	 * @return {Promise} The request promise.
	*/
	public getPublicKey = (): Promise<any> => {		
		return this._get('pk', {});
	}
}

export default StripeApi;